import { useConfiguratorStateDomain } from "@/configurator/domain/hooks/useConfiguratorStateDomain";
import { findProduct } from "@/configurator/domain/logic/catalog";
import {
  formatAmount,
  formatCurrencyLabel,
} from "@/configurator/domain/logic/money";
import { getTotalPrice } from "@/configurator/domain/logic/pricing";
import type { PriceView } from "@/configurator/domain/models/view";
import type { ConfiguratorSnapshot } from "@/configurator/domain/ports/configuratorState";

// Module scope keeps the identity stable — see the note in useConfiguratorDomain.
const selectQuantity = (s: ConfiguratorSnapshot) => s.quantity;

const selectTotal = (s: ConfiguratorSnapshot) =>
  getTotalPrice(
    findProduct(s.config.catalog, s.activeProductId),
    s.selectedOptions,
    s.quantity,
  );

export type PricingDomain = {
  quantity: number;
  /** Amount and currency separately, because the design styles them apart. */
  total: PriceView;
  setQuantity: (quantity: number) => void;
};

export function usePricingDomain(): PricingDomain {
  const { useSelect, commands } = useConfiguratorStateDomain();
  const quantity = useSelect(selectQuantity);
  const total = useSelect(selectTotal);

  return {
    quantity,
    total: {
      amount: formatAmount(total),
      currency: formatCurrencyLabel(total),
    },
    setQuantity: commands.setQuantity,
  };
}
